export default "__VITE_ASSET__7ybvCn1A__"